import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { SERVICE_OPERATOR, OPERATOR_ADDRESS, OPERATOR_VAT, SUPPORT_PHONE, SUPPORT_PHONE_RAW } from "@/lib/contact";

export default function LegalInformation() {
  return (
    <div className="min-h-screen bg-dapnow-bg">
      <header className="mx-auto max-w-4xl px-4 sm:px-6 py-6 flex justify-between items-center gap-4">
        <Logo size="lg" /><Link to="/" className="text-sm text-dapnow-blue font-semibold">Home</Link>
      </header>
      <main className="mx-auto max-w-3xl px-4 sm:px-6 py-10 sm:py-16 space-y-7" data-testid="legal-operator-page">
        <div>
          <p className="overline">Gestore e contatti</p>
          <h1 className="mt-2 font-display text-3xl sm:text-4xl font-bold tracking-tight">{SERVICE_OPERATOR}</h1>
          <p className="mt-4 text-dapnow-muted leading-relaxed">DapNow è il servizio di consegne gestito da SwissNat SA. Il marchio, il sito e il numero di contatto DapNow sono dedicati al servizio; la società responsabile è SwissNat SA.</p>
        </div>
        <section className="card-soft p-5 sm:p-7 space-y-3">
          <h2 className="font-display text-xl font-semibold">Operatore del servizio</h2>
          <p>SwissNat SA<br />{OPERATOR_ADDRESS}</p>
          <p>IDI / IVA: {OPERATOR_VAT}</p>
          <p className="text-sm text-dapnow-muted">Per richieste sul servizio, documenti di fatturazione o dati personali, contatta DapNow indicando il riferimento della richiesta o della spedizione.</p>
          <p className="break-words"><a href="mailto:support@dap-now.ch" className="text-dapnow-blue underline">support@dap-now.ch</a></p>
          <p><a href={`tel:+${SUPPORT_PHONE_RAW}`} className="text-dapnow-blue underline">{SUPPORT_PHONE}</a></p>
        </section>
        <section className="space-y-3 text-sm leading-relaxed">
          <h2 className="font-display text-xl font-semibold">Consegne in giornata</h2>
          <p>Il lancio operativo è in preparazione. L’area prevista comprende Ticino e Grigioni italiano, con servizio tutti i giorni dalle 06:30 alle 21:00, secondo disponibilità del team interno e del mezzo adatto alla spedizione.</p>
          <p>Il servizio per driver privati è in arrivo. Le richieste di informazioni non attivano un account operativo.</p>
          <p>Le notifiche automatiche WhatsApp sul numero DapNow non sono ancora attive. Puoi contattarci per telefono o email.</p>
        </section>
        <Link to="/" className="btn-secondary inline-flex">Torna a DapNow</Link>
      </main>
    </div>
  );
}
